module.exports = __webpack_public_path__ + "static/media/Frankenstein Monster.521d4159.jpg";